import APIClient from '../../../common/APIClient';
import { toggleShowAlert, displayError, SUCCESS_ALERT } from '../commonActions';

const SET_TASK_ASSIGNEE = 'SET_TASK_ASSIGNEE';
const FETCH_TASK_ASSIGNEES = 'FETCH_TASK_ASSIGNEES';
const RESET_TASK_ASSIGNEE = 'RESET_TASK_ASSIGNEE';
const UPDATE_TASK_ASSIGNMENT_HOURS = 'UPDATE_TASK_ASSIGNMENT_HOURS';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const createTaskAssignment = () => {
  return (dispatch, getState) => {
    const assignee = getState().projects.taskAssignee;
    const projectTask = getState().projects.projectTask;
    let value = {}
    if (typeof(projectTask.member) !== "null") {
       value = {
        id: projectTask.id, 
        user_id: assignee.member.value,
        hours: assignee.hours,
        startDate: assignee.startDate,
        endDate: assignee.endDate,
        targetActivity: assignee.targetActivity
      }
    }
    client().post(
      'task-assignment/create',
      value
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Task successfully assigned to " + assignee.member.label));
        dispatch(fetchProjectTaskAssignees(projectTask.id));
        dispatch(resetTaskAssignee());
      }
    }).catch(error => {
      dispatch(displayError(error));      
    })
  }
}

export const fetchProjectTaskAssignees = (project_task_id) => {
  return (dispatch) => {
    client().get(
      'task-assignment/list', {
        params: {
          id: project_task_id
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let data = result.data;
        if (data.length === 0) {
          data = null;
        }
        dispatch({type: FETCH_TASK_ASSIGNEES, taskAssignees: data});
      }
    }).catch(error => {
      dispatch(displayError(error))
    })
  }
}

export const deleteTaskAssignment = (id) => {
  return (dispatch, getState) => {
    const projectTask = getState().projects.projectTask;

    client().get(
      'task-assignment/delete', {
        params: {
          id 
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(fetchProjectTaskAssignees(projectTask.id));
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const resetTaskAssignee = () => {
  return (dispatch) => {
    dispatch({type: RESET_TASK_ASSIGNEE});
  }
}

export const updateTaskAssignment = (id, user_id, hours, startDate, endDate, targetActivity) => {
  return (dispatch, getState) => {
    const projectTask = getState().projects.projectTask;
    client().put(
      'task-assignment/update', {
        id, 
        user_id, 
        hours,
        startDate,
        endDate,
        targetActivity,
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Task assignment has been successfully updated."));
        dispatch(fetchProjectTaskAssignees(projectTask.id));
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const handleUpdateHours = (e, id) => {
  return (dispatch) => {
    const value = e.target.value;
    dispatch({type: UPDATE_TASK_ASSIGNMENT_HOURS, value, id})
  }
}

export const handleFieldChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value;
    if (e) {
      value = {
        [e.target.id]: e.target.value
      }
    }
    else {
      value = definedValue;
    }

    dispatch ({type: SET_TASK_ASSIGNEE, value});
  }
}

export const resetTaskAssignmentForm = () => (dispatch) => {
  dispatch({
    type: "RESET_TASK_ASSIGNMENT_FORM",
  });
};